import { render, staticRenderFns } from "./MImglive.vue?vue&type=template&id=14bf046e&scoped=true&"
import script from "./MImglive.vue?vue&type=script&lang=js&"
export * from "./MImglive.vue?vue&type=script&lang=js&"
import style0 from "./MImglive.vue?vue&type=style&index=0&id=14bf046e&scoped=true&lang=scss&"
import style1 from "./MImglive.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf046e",
  null
  
)

export default component.exports